import React from "react";
import { Grid } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

const FilterSection = ({
  handleFilterModalOpen,
  statusFilterOptions,
  creationDateFilterOptions,
  handleDeleteChip,
}) => {
  return (
    <Grid container direction={"column"} style={{ marginBottom: 8 }}>
      <Grid container alignItems={"center"} style={{ marginBottom: 8 }}>
        <span
          onClick={handleFilterModalOpen}
          style={{
            color: "#00A7CD",
            fontWeight: 700,
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            fontFamily: "Avenir Book, sans-serif",
          }}
        >
          <FilterAltOutlinedIcon fontSize="small" /> Filters
        </span>
      </Grid>

      <Grid container style={{ gap: 8 }}>
        {(creationDateFilterOptions || []).map((item, idx) => (
          <span
            key={`creation-${idx}`}
            style={chipStyles}
            onClick={() => handleDeleteChip("creationDate", item)}
          >
            {item} ×
          </span>
        ))}

        {(statusFilterOptions || []).map((item, idx) => (
          <span
            key={`status-${idx}`}
            style={chipStyles}
            onClick={() => handleDeleteChip("status", item)}
          >
            Status: {item} ×
          </span>
        ))}
      </Grid>
    </Grid>
  );
};

export default FilterSection;

const chipStyles = {
  background: "#E8F7FB",
  borderRadius: 16,
  padding: "6px 10px",
  fontSize: 12,
  cursor: "pointer",
  color: "#1B5765",
  fontFamily: "Avenir Book, sans-serif",
};

